module.exports = __webpack_public_path__ + "static/rob-c0e2ca4b4502c4b197e592b5a129de3c.jpg";